import { Typography } from "@mui/material";
import React from "react";
import DetailCaption from "./DetailCaption";
import SectionHeader from "./SectionHeader";

function Visitors() {
  return (
    <>
      <SectionHeader>Visitors</SectionHeader>
      <DetailCaption>
        Visitors are requested to abide by all Harmony Hill guidelines.
      </DetailCaption>
      <Typography variant="body2">
        <ul>
          <li>
            If you will have visitors coming to the singing school at any time
            during the week, including the closing session,{" "}
            <b>
              please make certain that they know our guidelines and our dress
              code.
            </b>
          </li>
        </ul>
      </Typography>
    </>
  );
}

export default Visitors;
